module.exports = __webpack_public_path__ + "static/media/affordable-housing-landing.0c9bc405.jpg";